import productReducer from './reducers'

export { default as productSelectors } from './selectors'
export { default as productActions } from './actions'
export { default as productTypes } from './actionTypes'

export default productReducer
